"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchGlobalEvent = dispatchGlobalEvent;
var _runtime = require("../constants/runtime");
const GLOBAL_EVENT_NAMESPACE = 'newrelic';
function dispatchGlobalEvent(detail = {}) {
  try {
    _runtime.globalScope.dispatchEvent(new CustomEvent(GLOBAL_EVENT_NAMESPACE, {
      detail
    }));
  } catch (err) {
    // something happened... dispatchEvent or CustomEvent might not be supported
    // decide what to do about it here
  }
}